import { Tag } from '@cian/components';
import * as React from 'react';

import { EEstateType } from '../../../../json_query';
import { IEstateTypeTag } from '../../../state/tags/definitions/estate_type';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IEstateTypeTagItemProps {
  tag: IEstateTypeTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

const estateTypeMap = {
  [EEstateType.Owned]: 'В собственности',
  [EEstateType.Rent]: 'В аренде',
};

export const EstateTypeTagItem = (props: IEstateTypeTagItemProps) => {
  const TagComponent = React.useMemo(() => (props.withNewTag ? TagNew : Tag), [props.withNewTag]);

  return (
    <TagComponent onDeleteClick={props.onDeleteClick} tagStyles={tagThemeSmall}>
      {estateTypeMap[props.tag.value]}
    </TagComponent>
  );
};
